// eslint-disable-next-line no-unused-vars
import axios from "axios";
export default {
  created: function () {},
  methods: {
    async SendNotification(message, type) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      const body = {
        message: message,
        type: type,
      };
      axios.post("https://api.jeak.co.uk/notification", body, config);
    },
  },
};
